import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import Location from '../components/Location';
import Contact from '../components/Contact';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-stone-50" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Location />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
